export default "__VITE_ASSET__CLOtkkib__"